export const SHORTLIST_PRODUCTS_LOAD = 'shortlist/SHORTLIST_PRODUCTS_LOAD';
export const SHORTLIST_PRODUCTS_SUCCESS = 'shortlist/SHORTLIST_PRODUCTS_SUCCESS';
export const SHORTLIST_PRODUCTS_FAIL = 'shortlist/SHORTLIST_PRODUCTS_FAIL';
